import type { FaireProductEntity } from "../../entity_types/product";

export const p_hjzbbyjpzr: FaireProductEntity = {
  token: "p_hjzbbyjpzr",
  type: "product",
  name: "ELEVATE Hydrogen Infused Water SUPERWATER (12-Pack)",
  brandToken: "b_jktyudpyb4",
  brandName: "ELEVATE Beverages",
  imageUrl:
    "https://cdn.faire.com/fastly/b05a25b9bc5ac4e14fe502cc2f1166074c9eb1d69a03c78fe15a8ce25c4b77a5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/06f9e6c1904e87ecd2a051e80398af6d31bfeac8b5cde54b2c7a49eaaf09a843.jpeg",
    "https://cdn.faire.com/fastly/0175a2c780ba2b7d4d173556814c010aaa37e59d24d60c9c89c45a63ebdf99cf.jpeg",
    "https://cdn.faire.com/fastly/8b42ee89b6e600be59daad8036aceb9b36f49c08189eb35e4ccf0d66780b3d07.jpeg",
    "https://cdn.faire.com/fastly/08b6aa8ab5950326031daeb467527bb595c538b5b83a7a0356c6c2d7c679ab79.jpeg",
    "https://cdn.faire.com/fastly/b26282d6e6c104981e231adac5e592b49dbc5b3cc9480ffce83fe2221cfb59fa.jpeg",
    "https://cdn.faire.com/fastly/60a274515cbe89f0cc3a3974f351322f124f4ef7dbcd6f6a5da9c1db966b056a.jpeg",
    "https://cdn.faire.com/fastly/04fa83f422f6bc2d0312ab1b31045b0b4d04002c057a5cd8886a90c408efddc1.jpeg",
  ],
  priceDollars: 32.42,
  description:
    "Introducing ELEVATE SUPERWATER, the ultimate alkaline water infused with unrivaled levels of infused hydrogen gas. Revolutionize hydration with our ready-to-drink hydrogen water that delivers energy, focus, recovery, and stress relief without chemicals, sugar, or caffeine.\n\nELEVATE SUPERWATER: Energize, Focus, Recover, Relax - Naturally!\n\nOur proprietary process transforms ordinary water into a powerful functional beverage. Experience the world's first and only SuperWater, loved by wholesalers and retailers.\n\n✓ Pristine Alkaline Water: Optimal hydration and purity.\n✓ Unmatched Hydrogen Levels: Boost well-being with the highest hydrogen concentration.\n✓ Chemical & Sugar-Free: Enjoy benefits without additives.\n✓ Multi-Benefit Drink: Energy, focus, hydration, recovery, and stress relief in one.\n\nTry ELEVATE SUPERWATER and join the hydration revolution today!\n\nINGREDIENTS:  12-Stage Ultra-Purified Structured Water, Celtic Sea Salt, Hydrogen Gas",
  tags: [],
  msrpDollars: 48.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:37.213Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
